// gkc_hash_code : 01EV64EDXCZTX8ZCEMHJHDQ126
import { Route } from 'react-router-dom';
import * as S from './styled';

import Header from 'components/primitive/Header';
import Footer from 'components/primitive/Footer';

const DefaultLayout = props => {
  const { exact, path, component: Component, ...other } = props;

  return (
    <Route
      exact={exact}
      path={path}
      render={routeProps => {
        return (
          <S.Layout id="main-wrapper">
            <Header />
            <Component {...other} {...routeProps} />
            <Footer />
          </S.Layout>
        );
      }}
    />
  );
};

export default DefaultLayout;
